import { useScreenFullHeight } from '@hooks/use-screen-full-height';
import { STEPS_MOBILE_TITLE } from '@modules/dashboard/pages/kyc/docs-verification/docs-verification-page/tabs/constants';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAppTheme } from '@theme';

export const useMobileHeight = () => {
    const theme = useAppTheme();
    const matchesMobileSm = useMediaQuery(`(max-width:${theme.breakPoints.sm})`);
    const { height } = useScreenFullHeight();
    const stepsMobileTitleNode = window.document.getElementById(STEPS_MOBILE_TITLE);

    return {
        minHeight:
            matchesMobileSm && height
                ? height -
                  32 -
                  (stepsMobileTitleNode?.clientHeight ? stepsMobileTitleNode.clientHeight : 0) -
                  34 // language-selector
                : undefined,
    };
};
